import { useEffect } from 'react';
import { cancelFunctions } from 'utils/cancelFunctions';

const NON_CANCELLABLE_ON_UNMOUNT = ['FETCH_PENDING_CREATIVE_COUNT'];

export const useCancelRequest = (): void => {
  useEffect(() => {
    return () => {
      Object.entries(cancelFunctions).forEach(([key, cancel]) => {
        if (!NON_CANCELLABLE_ON_UNMOUNT.includes(key)) {
          cancel();
          delete cancelFunctions[key];
        }
      });
    };
  }, []);
};
